import { vector, multiply, subtract } from '@lib/util/vector'

import {
  BASE_SCALE,
  POM_RADIUS,
  ROW_LENGTH
} from '@game/constants'

const options = {
  viewport: {
    x: 0,
    y: 0
  }
}

export function setTranslateOpts (newOptions) {
  for (const key in newOptions) {
    options[key] = newOptions[key]
  }
}

let x, y, w, h, scale

export function translatePomPos (i) {
  x = i % ROW_LENGTH
  x -= 0.25
  y = Math.floor(i / ROW_LENGTH)
  if (y % 2 === 1) x += 0.5

  scale = BASE_SCALE
  h = (ROW_LENGTH - 1) * POM_RADIUS * scale
  w = (ROW_LENGTH - 0.5) * POM_RADIUS * scale

  x *= POM_RADIUS * scale
  x += options.viewport.x / 2
  x -= w / 2
  y *= POM_RADIUS * scale
  y += options.viewport.y / 2
  y -= h / 2

  return vector(x, y)
}

export function scaleToPom () {
  scale = BASE_SCALE
  const values = Array.from(arguments).map(val => val * scale)
  if (values.length === 1) return values[0]
  return values
}

export function pomScreenOffset (i) {
  const pos = translatePomPos(i)
  return multiply(subtract(multiply({ ...options.viewport }, 0.5), pos), -1)
}
